export type PersistFn<T> = (storageKey: string, value: T) => void | Promise<void>;

export function createPersistScheduler<T>(persist: PersistFn<T>, delayMs = 250) {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  let latest: { storageKey: string; value: T } | undefined;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
  }

  async function flush() {
    cancel();
    if (!latest) {
      return false;
    }
    const payload = latest;
    latest = undefined;
    await persist(payload.storageKey, payload.value);
    return true;
  }

  function schedule(storageKey: string, value: T) {
    latest = { storageKey, value };
    cancel();
    timeoutId = setTimeout(() => {
      void flush();
    }, delayMs);
  }

  return { schedule, flush, cancel };
}
